import { useState, useMemo, useEffect } from 'react';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { useLocalStorage } from 'src/shared/hooks/useLocalStorage';
import { LocalStorageKeys } from 'src/shared/models/enums/localStorageKeys.enum';
import SearchField from 'src/shared/components/form/searchField';
import { PageFilterSection } from 'src/shared/components/organisms/pageFilterSection';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { AutogiroMandateSentEnum } from 'src/shared/models/enums/autogiroMandateSent.enum';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'src/shared/models/enums/gridFilterConfig';
import { AutogiroSearchFilter } from '../models/autogiroSearchFilter';
import { AutogiroFileDataGrid } from '../components/autogiroFileDataGrid';

export const AutogiroCreateFileOverviewPage = () => {
  const isMounted = useIsMounted();
  const [tempSearchString, setTempSearchString] = useState<string | undefined>(undefined);
  const [searchInitialized, setSearchInitialized] = useState<boolean>(false);
  const [autogiroSearchFilter, setAutogiroSearchFilter] = useLocalStorage(LocalStorageKeys.AutogiroCreateFileSearchFilter, {
    sortCol: 'autogiroMandate_id',
    sortDir: 'desc',
    pageIndex: DEFAULT_PAGE_INDEX,
    pageSize: DEFAULT_PAGE_SIZE,
    sent: AutogiroMandateSentEnum.NotSent,
  } as AutogiroSearchFilter);

  const searchFilter: AutogiroSearchFilter = useMemo(() => {
    return {
      filter: autogiroSearchFilter?.filter,
      pageSize: autogiroSearchFilter?.pageSize,
      pageIndex: autogiroSearchFilter?.pageIndex,
      sortCol: autogiroSearchFilter?.sortCol,
      sortDir: autogiroSearchFilter?.sortDir,
      sent: autogiroSearchFilter?.sent,
    } as AutogiroSearchFilter;
  }, [
    autogiroSearchFilter?.filter,
    autogiroSearchFilter?.pageIndex,
    autogiroSearchFilter?.pageSize,
    autogiroSearchFilter?.sent,
    autogiroSearchFilter?.sortCol,
    autogiroSearchFilter?.sortDir,
  ]);

  useEffect(() => {
    if (isMounted() && searchInitialized) {
      if (tempSearchString === '') {
        setAutogiroSearchFilter((prev) => ({ ...prev, ...{ filter: '', pageIndex: 0 } }));
      }
      if (tempSearchString && tempSearchString.length >= 2) {
        setAutogiroSearchFilter((prev) => ({ ...prev, ...{ filter: tempSearchString, pageIndex: 0 } }));
      } else {
        setAutogiroSearchFilter((prev) => ({ ...prev, ...{ filter: '', pageIndex: 0 } }));
      }
    }
  }, [isMounted, searchInitialized, setAutogiroSearchFilter, tempSearchString]);

  return (
    <>
      <PageFilterSection
        leftContent={
          <SearchField
            initialValue={searchFilter.filter || ''}
            onSearch={(newSearchString) => {
              setSearchInitialized(true);
              setTempSearchString(newSearchString);
            }}
          />
        }
      />
      <AutogiroFileDataGrid
        loadingCallback={(x) => ConsoleHelper.log(x)}
        searchFilter={searchFilter}
        searchFilterCallback={(newFilter) =>
          setAutogiroSearchFilter((prev) => ({
            ...prev,
            ...newFilter,
          }))
        }
        checkboxSelection
      />
    </>
  );
};
